import { isSuccess, Result } from '@carvana/merch-result';
import { httpWithAuth } from '~/clients';
import { getTradesV2 } from '~/constants/endpoints';
import TradeInPreviewAcquisition from '~/contracts/common/Trade';
import { MerchUiTradeV2Response } from '~/pages/api/trades/v2/get';

export default async function fetchTradeInPreviewAcquisitions(
  correlationId: string
): Promise<TradeInPreviewAcquisition[]> {
  const url = getTradesV2({ currentPageUrl: window.location.href });

  const { data } = await httpWithAuth.get<Result<MerchUiTradeV2Response>>(url, {
    headers: {
      'x-client-id': '40b6459c-f085-455f-ae19-d8070cbf9f5c',
      'x-correlation-id': correlationId
    }
  });

  return isSuccess(data) ? data.content.trades : [];
}
